var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoolBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2992_916)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2992_916)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2992_916",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -3,
    width: 56,
    height: 57
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8504 -2.09961H-1.34961V53.1004H53.8504V-2.09961Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2992_916)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2992_916",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 49,
    height: 47
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 2.5H52.5679V48.5H4.75V2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2992_916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9922 18.4857H48.3019C48.6169 18.4854 48.9189 18.3648 49.1416 18.1506C49.3643 17.9363 49.4896 17.6458 49.49 17.3428V15.0407C49.4892 14.7378 49.3638 14.4476 49.1411 14.2335C48.9185 14.0195 48.6167 13.899 48.3019 13.8984H45.9922",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.998 44.6309H31.2991",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7859 9.61328C18.4269 9.95323 17.0989 10.8235 18.3916 12.681C18.7553 13.1677 18.9118 13.7698 18.829 14.3639C18.7463 14.958 18.4304 15.4992 17.9463 15.8765",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8883 9.61328C24.5349 9.95323 23.2012 10.8235 24.4939 12.681C24.8577 13.1677 25.0142 13.7698 24.9314 14.3639C24.8486 14.958 24.5328 15.4992 24.0487 15.8765",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9043 27.0517V27",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0955 11.8571V3.68127C34.0955 3.33044 34.0361 3.15503 34.6185 3.17542C48.4111 3.66563 49.8409 23.7431 38.9121 28.2991M34.0955 24.3829V15.0098",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9028 23.8633C35.0318 23.8638 34.1967 24.197 33.581 24.7896C32.9653 25.3821 32.6193 26.1856 32.6191 27.0235C32.6191 27.8616 32.965 28.6655 33.5806 29.2585C34.1963 29.8516 35.0315 30.1853 35.9028 30.1864C36.3347 30.1864 36.7623 30.1047 37.1613 29.9458C37.5604 29.7869 37.9229 29.5539 38.2284 29.2602C38.5338 28.9665 38.7761 28.6178 38.9415 28.2341C39.1069 27.8503 39.192 27.4389 39.1921 27.0235C39.192 26.6081 39.1068 26.1969 38.9414 25.8133C38.7761 25.4296 38.5337 25.0811 38.2282 24.7876C37.9227 24.4941 37.5601 24.2615 37.1611 24.1028C36.7621 23.9442 36.3345 23.8628 35.9028 23.8633Z",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2734 37.6444L32.5537 46.8761C32.7834 47.2743 33.1675 47.569 33.6223 47.6956C34.0771 47.8222 34.5655 47.7706 34.9808 47.5519C35.3949 47.3318 35.7013 46.9627 35.833 46.5255C35.9647 46.0884 35.9109 45.6189 35.6833 45.2198L30.6179 36.3594C29.5579 36.9095 28.4357 37.3407 27.2734 37.6444Z",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9603 37.7074L12.68 46.9384C12.4505 47.3368 12.0667 47.6318 11.6121 47.7592C11.1574 47.8865 10.6689 47.8359 10.253 47.6183C9.83878 47.3975 9.53208 47.0282 9.3997 46.5909C9.26731 46.1536 9.31996 45.6836 9.54619 45.2835L14.5883 36.4727C15.6603 37.0052 16.7915 37.4194 17.9603 37.7074Z",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54564 29.9554C8.11342 28.7538 7.87205 27.4963 7.82968 26.2254C7.80848 25.619 8.00425 25.6815 8.40075 25.6815H32.9256M36.3613 30.158C32.5588 39.9594 16.2424 40.8664 10.1387 32.8606",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2285 25.6784V22.9792C12.23 22.4993 12.4289 22.0394 12.7816 21.7001C13.1344 21.3607 13.6124 21.1694 14.1113 21.168H29.0864C29.5857 21.1689 30.0644 21.3599 30.4177 21.6993C30.7711 22.0387 30.9704 22.4989 30.972 22.9792V25.6805",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5806 21.166L21.2188 22.8175",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.733 21.166L17.3711 22.8175",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3287 21.166L24.9668 22.8175",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2992_916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 52,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2992_916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.2,
    height: 55.2,
    fill: "white",
    transform: "translate(-1.34961 -2.09961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolBar);
export default __webpack_public_path__ + "static/media/pool-bar.06389b3340b019c03f583a466395d0be.svg";
export { ForwardRef as ReactComponent };